import axios from './axiosInstances/axiosInstance';

export const retrieveBasketQualifyingRewards = (basketId, printedCardNumber) => {
  return axios.get(`baskets/${basketId}/loyaltyrewards/qualifying?printedCardNumber=${printedCardNumber}`);
};
